import styled from 'styled-components';

export const Count = styled.div`
    float: right;
}
`;
